<template>
  <div :class="popupClasses" id="modal-change">
    <div class="close__wrapper close__wrapper-center">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>

      <div class="header__popup column">
        <span class="header__popup-title">Изменение пароля</span>
      </div>
      <ValidationObserver v-slot="{ passes }">
        <form class="footer__popup" @submit.prevent="passes(Submit)">
          <div class="inputblock__full">
            <span class="subtitle">
              Старый пароль
            </span>
            <AppInput
              class=""
              rules="required"
              v-bind="{
                bg,
                label: 'Введите старый пароль',
                type: oldpasswordType,
                pass: true
              }"
              @updatePass="updateoldPass"
              v-model="old_password"
            />
          </div>
          <div class="inputblock__full">
            <span class="subtitle">
              Новый пароль
            </span>
            <AppInput
              class=""
              rules="required|password:@confirm"
              v-bind="{
                bg,
                label: 'Новый пароль',
                type: passwordType,
                pass: true
              }"
              @updatePass="updatePass"
              v-model="new_password"
            />
          </div>
          <div class="inputblock__full">
            <span class="subtitle">
              Повторите новый пароль
            </span>
            <AppInput
              class=""
              name="confirm"
              rules="required"
              v-bind="{
                bg,
                label: 'Повторите новый пароль',
                type: passwordConfirmType,
                pass: true
              }"
              @updatePass="updateConfirmPass"
              v-model="re_new_password"
            />
          </div>
          <button type="submit" class="redbtn">Изменить пароль</button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
//
import AppInput from "@/components/ui/AppInput.vue";
import { mapActions } from "vuex";
//
export default {
  name: "LoginModal",
  props: ["modal", "bg"],
  //
  data() {
    return {
      oldpasswordType: "password",
      passwordType: "password",
      passwordConfirmType: "password",

      old_password: "",
      new_password: "",
      re_new_password: ""
    };
  },
  computed: {
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },
  methods: {
    ...mapActions("modals", ["closeModal"]),
    /*     showToast() {
      this.$toast.success("Пароль изменен", {
        position: "top-center"
      });
    }, */
    updatePass(val) {
      if (val) this.passwordType = "text";
      else this.passwordType = "password";
    },
    updateoldPass(val) {
      if (val) this.oldpasswordType = "text";
      else this.oldpasswordType = "password";
    },
    updateConfirmPass(val) {
      if (val) this.passwordConfirmType = "text";
      else this.passwordConfirmType = "password";
    },
    Submit() {
      return this.modal
        .success({
          old_password: this.old_password,
          new_password: this.new_password
        })
        .then(response => {
          if (response) {
            this.closeModal(this.modal.name);
          }
          /*           this.showToast(); */
          //
          return response;
        });
    }
  },
  components: { AppInput }
};
</script>

<style scoped>
.inputblock__full {
  padding: 15px 10px 0px 20px;
  border-radius: 20px;
  flex: 1 0 0;
  border: 2px solid var(--main-black);
  border-bottom: 4px solid var(--main-black);
}

.subtitle {
  color: rgba(26, 24, 20, 0.4);
}
/* .modal-change {
  z-index: 1000;
  display: block;
  width: 330px;
  max-height: 400px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.popup-close {
  float: right;
  width: 22px;
  height: 22px;
  background-image: "@/assets/img/sprites/close.png";
  margin-top: 3px;
}

.popup-close:hover {
  cursor: pointer;
} */
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/ChangePassword.vue